module.exports = __webpack_public_path__ + "media/acuity/micro_themes-0a5a54d6.svg";